import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
// eslint-disable-next-line no-restricted-imports
import { CpaProductModel } from '../../../data-layer/cpa/types';
import { Flex } from '../../layout/Flex';
import { AdvertisingCatalogEmpty } from '../AdvertisingCatalogEmpty/AdvertisingCatalogEmpty';
import { AdvertisingProductCard } from '../AdvertisingProductCard/AdvertisingProductCard';
import { AdvertisingProductCardSkeleton } from '../AdvertisingProductCard/parts/AdvertisingProductCardSkeleton/AdvertisingProductCardSkeleton';
import { AdvertisingProductOffersDialog } from '../AdvertisingProductOffersDialog/AdvertisingProductOffersDialog';
import { PRODUCT_CARD_WIDTH, SKELETON_COUNT } from './constants';
import type { AdvertisingProductsProps } from './types';

export const AdvertisingProducts: React.FC<AdvertisingProductsProps> = ({
    isLoading,
    products,
}) => {
    const [visibleOffersDialog, setVisibleOffersDialog] = useState(false);
    const [offers, setOffers] = useState<CpaProductModel['offers']>([]);

    const onMoreButtonClick = useCallback((value: CpaProductModel['offers']) => {
        setOffers(value);
        setVisibleOffersDialog(true);
    }, []);
    const onClose = useCallback(() => {
        setOffers([]);
        setVisibleOffersDialog(false);
    }, []);

    if (!products || isLoading) {
        return (
            <Flex
                flexWrap="wrap"
                direction={{ sm: 'row' }}
                alignItems="stretch"
                width="100%"
                spacing={1}
            >
                {new Array(SKELETON_COUNT).fill('').map(() => (
                    <AdvertisingProductCardSkeleton width={PRODUCT_CARD_WIDTH} />
                ))}
            </Flex>
        );
    }

    if (products?.length) {
        return (
            <Flex
                flexWrap="wrap"
                direction={{ sm: 'row' }}
                alignItems="stretch"
                width="100%"
                spacing={1}
            >
                {products.map((product) => (
                    <AdvertisingProductCard
                        {...product}
                        width={PRODUCT_CARD_WIDTH}
                        onMoreButtonClick={onMoreButtonClick}
                    />
                ))}
                {visibleOffersDialog
                    ? createPortal(
                          <AdvertisingProductOffersDialog offers={offers} onClose={onClose} />,
                          document.body,
                      )
                    : null}
            </Flex>
        );
    }

    return <AdvertisingCatalogEmpty />;
};
